<template>
  <div class="relative item">
    <Loading v-if="loading" />

    <v-sheet v-else color="#cccccc">
      <img
        width="100%"
        :src="
          files +
          (xs && item.bottom_banner_mobile
            ? item.bottom_banner_mobile
            : item.bottom_banner_desktop)
        "
        min-height="400px"
        :aspect-ratio="xs ? 600 / 600 : 1920 / 400"
        class="d-flex align-center justify-center pointer-none"
      />
    </v-sheet>
  </div>
</template>

<script>
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-banners",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    informations: {},
    item: {},
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest("pages-informations").get({
      id: this.mod,
      save: (state, data) => (this.informations = data),
    });

    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
  },
};
</script>
